import React from 'react';
import styles from './layout.scss';

const Layout = ({ children }) => {
  return (
    <main className={styles.layout}>
      {children}
    </main>
  );
};

export default Layout;